import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { AlreadyTranslated, T } from '../../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { ExperienceResource } from '../../../../ExperienceCatalog/Types';
import SelectableDates from './SelectableDates';
import SubmitButton from './SubmitButton';

export interface Props {
  experienceResource: ExperienceResource;
  close: () => void;
  experienceStore: LearningDesignExperienceStore;
  store: LearningCollectionEditStore;
}

function Body({ experienceResource, close, experienceStore, store }: Props) {
  return store.selectedProductLicense
    .map((productLicense) => (
      <div className="flex flex-col px-8">
        <div className="flex items-center">
          <div className="text-xl font-semibold">
            <T kind="Update Start Dates" />
          </div>
        </div>
        <div className="mt-4">
          <T kind="Select one or more dates for participants to choose from when enrolling." />
        </div>
        <div>
          <T kind="(Note: participants may only enroll in one-date per program)" />
        </div>
        <div className="mt-8 font-semibold">
          <T kind="Program" />
        </div>
        <div className="mt-2">
          <AlreadyTranslated content={experienceResource.payload.title} />
        </div>
        <div className="mt-8 font-semibold">
          <T kind="Select Start Date(s)" />
        </div>
        <SelectableDates
          experienceResource={experienceResource}
          experienceStore={experienceStore}
          productLicense={productLicense}
        />
        <SubmitButton
          experienceResource={experienceResource}
          close={close}
          experienceStore={experienceStore}
          store={store}
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Body);
